import firebase from 'firebase/app'
import { getAuth } from 'firebase/auth'

export type BearerToken = string

export async function mintBearerToken(
  firebaseApp: firebase.FirebaseApp,
): Promise<BearerToken> {
  const bearerToken = await getAuth(firebaseApp)?.currentUser?.getIdToken()
  if (bearerToken === null || bearerToken === undefined) {
    throw Error(
      'Failed to generate bearer token for logged-in user: reason unknown',
    )
  }

  return bearerToken
}
